import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import {
  ClientPurchaseOrder,
  ClientPurchaseOrderDetailsDto,
  ClientPurchaseOrderInsert,
  ClientPurchaseOrderSearchCommand,
} from '../../models/client-purchase-order/client-purchase-order';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ClientPurchaseOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/client-purchase-order';

  getById(id: string): Observable<ApiResponse<ClientPurchaseOrder>> {
    return this.httpClient.get<ApiResponse<ClientPurchaseOrder>>(`${this.baseUrl}/${id}`);
  }

  getDetailsById(id: string): Observable<ApiResponse<ClientPurchaseOrderDetailsDto>> {
    return this.httpClient.get<ApiResponse<ClientPurchaseOrderDetailsDto>>(`${this.baseUrl}/${id}/details`);
  }

  create(data: ClientPurchaseOrderInsert): Observable<ApiResponse<ClientPurchaseOrder>> {
    return this.httpClient.post<ApiResponse<ClientPurchaseOrder>>(this.baseUrl, data);
  }

  update(data: ClientPurchaseOrder): Observable<ApiResponse<ClientPurchaseOrder>> {
    return this.httpClient.put<ApiResponse<ClientPurchaseOrder>>(`${this.baseUrl}/${data.id}`, data);
  }

  changeStatus(id: string, status: number): Observable<ApiResponse<ClientPurchaseOrder>> {
    return this.httpClient.patch<ApiResponse<ClientPurchaseOrder>>(`${this.baseUrl}/${id}/status`, status);
  }

  delete(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }

  search(
    command: ClientPurchaseOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<ClientPurchaseOrder>>> {
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder !== undefined) params = params.set('sortOrder', sortOrder.toString());
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ClientPurchaseOrder>>>(`${this.baseUrl}/search`, command, { params });
  }
}
